// Carrier chooser for the pallet desk: shown on the pack and confirm screens
// while an order is still ready and more than one enabled pallet carrier
// serves its country (JAS and Raben both serve Poland). A segmented radio
// group; the default is the order's own carrier. The one primary action on
// the screen stays the big Ship / proceed button.
import { Truck } from "lucide-react";
import { useTranslation } from "../../i18n";
import type { DeskCarrier } from "./palletDesk";

interface Props {
    options: DeskCarrier[];
    value: string | null;
    onChange: (code: string) => void;
    disabled?: boolean;
}

const PalletCarrierChooser = ({ options, value, onChange, disabled }: Props) => {
    const { t } = useTranslation();
    if (options.length < 2) return null;
    return (
        <div className="pallet-carrier-chooser" role="radiogroup" aria-label={t("pallet_dispatch_choose_carrier")}>
            <span className="pallet-carrier-chooser-label"><Truck size={16} aria-hidden="true" /> {t("pallet_dispatch_choose_carrier")}</span>
            <div className="pallet-carrier-chooser-options">
                {options.map((c) => (
                    <button
                        key={c.code}
                        type="button"
                        role="radio"
                        aria-checked={c.code === value}
                        className={`btn btn-secondary pallet-carrier-chooser-btn${c.code === value ? " pallet-carrier-chooser-btn--active" : ""}`}
                        disabled={disabled}
                        onClick={() => onChange(c.code)}
                    >
                        {c.name}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default PalletCarrierChooser;
